export const hideIfEmpty = (event) => {
  if (event.isEmpty) {
    const parentElement = document.getElementById(event.slot.getSlotElementId()).parentNode;

    parentElement.style.display = 'none';
  }
}
